import PDFConverter from './components/PDFConverter';
import './App.css';

function App() {
  return (
    <div className="app " style={{ fontFamily: 'product-sans' }}>
      <PDFConverter />
    </div>
  );
}

export default App;

